/* eslint-disable sonarjs/no-duplicate-string */

import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  doplnkovaSluzbaLabel: {
    id: "b2b.autocompletes.doplnkove-sluzby.label",
    defaultMessage: "Additional service"
  },
  doplnkovaSluzbaPlaceholder: {
    id: "b2b.autocompletes.doplnkove-sluzby.placeholder",
    defaultMessage: "Select additional service"
  },
  doplnkovaSluzbaLabelMultiple: {
    id: "b2b.autocompletes.doplnkove-sluzby.label-multiple",
    defaultMessage: "Additional services"
  },
  doplnkovaSluzbaPlaceholderMultiple: {
    id: "b2b.autocompletes.doplnkove-sluzby.placeholder-multiple",
    defaultMessage: "Select additional services"
  },
  zakazniciLabel: {
    id: "b2b.autocompletes.zakaznici.label",
    defaultMessage: "Customer"
  },
  zakazniciPlaceholder: {
    id: "b2b.autocompletes.zakaznici.placeholder",
    defaultMessage: "Select customer"
  },
  uzivateleLabel: {
    id: "b2b.autocompletes.uzivatele.label",
    defaultMessage: "User"
  },
  uzivatelePlaceholder: {
    id: "b2b.autocompletes.uzivatele.placeholder",
    defaultMessage: "Select user"
  },
  produktyLabel: {
    id: "b2b.autocompletes.produkty.label",
    defaultMessage: "Product"
  },
  produktyPlaceholder: {
    id: "b2b.autocompletes.produkty.placeholder",
    defaultMessage: "Select product"
  },
  produktyLabelMultiple: {
    id: "b2b.autocompletes.produkty.label-multiple",
    defaultMessage: "Products"
  },
  produktyPlaceholderMultiple: {
    id: "b2b.autocompletes.produkty.placeholder-multiple",
    defaultMessage: "Select products"
  },
  projektyLabel: {
    id: "b2b.autocompletes.projekty.label",
    defaultMessage: "Project"
  },
  projektyPlaceholder: {
    id: "b2b.autocompletes.projekty.placeholder",
    defaultMessage: "Select project"
  },
  smlouvyLabel: {
    id: "b2b.autocompletes.smlouvy.label",
    defaultMessage: "Contract"
  },
  smlouvyPlaceholder: {
    id: "b2b.autocompletes.smlouvy.placeholder",
    defaultMessage: "Select contract"
  },
  zdrojLabel: {
    id: "b2b.autocompletes.zdroj.label",
    defaultMessage: "Resource"
  },
  zdrojPlaceholder: {
    id: "b2b.autocompletes.zdroj.placeholder",
    defaultMessage: "Select source"
  },
  zadostiStavLabel: {
    id: "b2b.autocompletes.zadosti-stav.label",
    defaultMessage: "Request status"
  },
  zadostiStavPlaceholder: {
    id: "b2b.autocompletes.zadosti-stav.placeholder",
    defaultMessage: "Select request status"
  }
});

export default () => useMessages(MESSAGES);
